import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from 'react-router-dom';
import { Box, AspectRatio, List, ListItem, ListItemButton, ListItemDecorator, ListItemContent } from "@mui/joy";
import { getClientUser } from "../helpers/UserAccounts";
import MicIcon from '@mui/icons-material/Mic';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import GetHelp from "../components/RenderHelpDisplay";


function NavigationBar() {
    const location = useLocation();
    const [user, setUser] = useState(null);

    useEffect(() => {
        const getNowUser = async () => {
            const response = await getClientUser();
            setUser(response);
        };
        
        getNowUser();
    }, []);

    const isActive = (path) => {
        return location.pathname.includes(path);
    }

    return <Box sx={{display: "flex", height: "100vh"}}>
        <Box sx={{display: {xs: "none", sm: "flex"}, flexDirection: "column", flexGrow: 1, borderRight: "2px solid #f1f3f4"}}>
            <AspectRatio objectFit='contain' sx={{ padding: '5px', paddingLeft: "10px", paddingRight: "10px", backgroundColor:'inherit' }} variant='plain'>
                <img src="/assets/backgroundlogo.png" alt='Logo'/>
            </AspectRatio>
            <List component="nav" sx={{ backgroundColor: 'primary.main', padding: '10px' }}>
                {user && user.type === "individual" && <ListItem>
                    <ListItemButton component={NavLink} to="/new-report" sx={{ backgroundColor: isActive('/new-report') ? '#f1f3f4' : 'inherit' }}>
                        <ListItemDecorator> <MicIcon color={isActive('/new-report') ? '600' : 'inherit'} fontSize='xl3'/></ListItemDecorator>
                        <ListItemContent sx={{ fontSize: '1.3rem', fontWeight: isActive('/new-report') ? '700' : 'inherit', p: 1 }}> Current Report </ListItemContent>
                    </ListItemButton>
                </ListItem>}

                <ListItem sx={{display: "block", backgroundColor: isActive('/past-reports') ? '#f1f3f4' : 'inherit'}}>
                    <ListItemButton component={NavLink} to="/past-reports">
                        <ListItemDecorator> <HistoryIcon color={isActive('/past-reports') ? '600' : 'inherit'} fontSize='xl3'/></ListItemDecorator>
                        <ListItemContent sx={{ fontSize: '1.3rem', fontWeight: isActive('/past-reports') ? '700' : 'inherit', p: 1 }}> Past Reports</ListItemContent>
                    </ListItemButton>
                </ListItem>

                <ListItem>
                    <ListItemButton component={NavLink} to="/account" sx={{ backgroundColor: isActive('/account') ? '#f1f3f4' : 'inherit' }}>
                        <ListItemDecorator> <SettingsIcon color={isActive('/account') ? '600' : 'inherit'} fontSize='xl3'/></ListItemDecorator>
                        <ListItemContent sx={{ fontSize: '1.3rem', fontWeight: isActive('/account') ? '700' : 'inherit', p: 1 }}> Settings </ListItemContent>
                    </ListItemButton>
                </ListItem>

                <ListItem>
                    <ListItemButton component={NavLink} to="/sign-out" sx={{ backgroundColor: isActive('/logout') ? '#f1f3f4' : 'inherit' }}>
                        <ListItemDecorator> <LogoutIcon color={isActive('/sign-out') ? '600' : 'inherit'} fontSize='xl3'/></ListItemDecorator>
                        <ListItemContent sx={{ fontSize: '1.3rem', fontWeight: isActive('/sign-out') ? '700' : 'inherit', p: 1 }}> Sign Out </ListItemContent>
                    </ListItemButton>
                </ListItem>
            </List>
            {user && <GetHelp user={user}/>}
        </Box>
    </Box>

}

export default NavigationBar;